<template>
  <div id="app" @click="bodyClick">
    <mzheader :link="headerLink"></mzheader>
    <h1 class="title">{{ useLang.title }}</h1>
    <mzprogress :steps="useStep" :actived="1" size="126"></mzprogress>
    <div class="content content-form">
      <div class="section">
        <div class="bar bar-input">
          <mzinput
            :placeholder="useLang.accountHolder"
            :type="'account'"
            :label="useLang.accountLabel"
            v-model="account"
            ref="accountInput"
          ></mzinput>
        </div>
        <a class="link"></a>
      </div>
      <div v-show="verifyType === 2" class="section">
        <div class="bar bar-input">
          <mzinput
            :placeholder="useLang.varCodeHolder"
            :type="'imgCode'"
            :label="useLang.varCodeLabel"
            v-model="varCode"
            ref="kapkeyInput"
            :maxlen="6"
            :title="useInput.title"
          ></mzinput>
        </div>
        <a class="link"></a>
      </div>
      <div v-show="verifyType === 1" class="section">
        <Geet
          class="bar bar-input geet"
          :lang="geet_lang"
          @geetPath="GeetPath"
          @changeVerifyType="changeVerifyType"
          ref="geetBtn"
        ></Geet>
      </div>
      <div v-show="verifyType === 0" class="section section-loading">
        {{ useLang.loading }}
      </div>
    </div>
    <div class="content content-btn">
      <div class="btn-next">
        <btn
          :type="'blue'"
          :text="useLang.btn"
          @clicked="checkBeforeNext"
        ></btn>
      </div>
      <a
        href="https://i.flyme.cn/appeal"
        class="link"
        target="_Blank"
        v-if="!isInternational"
        >{{ useLang.complaintLink }}</a
      >
    </div>
    <div class="mask" v-show="showModal"></div>
    <mz-modal :title="useModal.title" v-show="showModal" @close="closeModal">
      <div class="modal-main">
        <p class="modal-tips">{{ message }}</p>
        <div class="modal-btn-container">
          <div class="modal-btn">
            <btn
              :type="'blue'"
              :text="useModal.okBtn"
              @clicked="closeModal"
            ></btn>
          </div>
        </div>
      </div>
    </mz-modal>
    <mzfooter
      :now-lang="nowLang"
      :lang-menu-item="langMenuItem"
      @translate="translate"
    ></mzfooter>
  </div>
</template>

<script>
import mzheader from "../../components/header/header.vue";
import mzprogress from "../../components/progress/progress.vue";
import btn from "../../components/button/button.vue";
import mzinput from "../../components/input/input.vue";
import mzfooter from "../../components/footer/footer.vue";
import axios from "axios";
import mzModal from "../../components/mzModal/mzModal.vue";
import { getParams } from "../../assets/utils.js";
import globalMethods from "../../assets/mixin.js";
import {
  forgetPwd_index,
  forgetPwdStep,
  inputLang,
  modalLang
} from "../../assets/lang.js";
import Geet from "../../components/geet/geet.vue";

export default {
  name: "app",
  components: {
    mzheader,
    mzprogress,
    btn,
    mzinput,
    mzModal,
    mzfooter,
    Geet
  },
  mixins: [globalMethods],
  data() {
    return {
      account: "",
      varCode: "",
      showModal: false,
      message: "",
      languageObject: forgetPwd_index,
      steps: forgetPwdStep,
      modalLangObject: modalLang,
      inputLangObject: inputLang,
      verifyType: 0, // 0：加载中，1：极验，2：验证码

      geetest_param: {
        gt_state: false
      }, //极验参数以及判断是否进行了极验校验
      geet_lang: "zh_cn"
    };
  },
  methods: {
    GeetPath(val) {
      this.geetest_param = val;
    },
    checkBeforeNext() {
      let account;
      if (this.$refs.accountInput.showCode) {
        account =
          "00" +
          this.$refs.accountInput.countryCode.code +
          ":" +
          this.account.trim();
      } else {
        account = this.account.trim();
      }
      if (account === "") {
        this.$refs.accountInput.showInputTips(this.useLang.AccountEmptyTips);
        return;
      }
      //根据verifyCode来判断有没有进行不同的验证方式。
      switch (this.verifyType) {
        //正处于加载中
        case 0:
          return;
        //未进行极验
        case 1:
          if (!this.geetest_param.gt_state) {
            return this.$refs.geetBtn.showInputTips(this.useLang.geetTips);
          } else{
            break;
          }
        //未输入验证码
        case 2:
          if (this.varCode === "") {
            return this.$refs.kapkeyInput.showInputTips(this.useLang.varCodeHolder);
          } else{
            break;
          }
        default:
          return;
      }
      this.next(account);
    },
    next(account) {
      let data = {
        account: account,
        kapkey: this.varCode,
        ...this.geetest_param
      };
      delete data.gt_state;

      axios.post("/uc/system/webjsp/forgetpwd/checkAccount", data).then(
        res => {
          if (res.data.code !== "200") {
            if (res.data.code == "403002" && this.verifyType === 2) {
              this.$refs.kapkeyInput.showInputTips(res.data.message);
            } else {
              this.$refs.accountInput.showInputTips(res.data.message);
            }
            this.refreshVerify();
          } else {
            location.href = res.data.value;
          }
        },
        err => {
          this.showModal = true;
          this.message = this.useLang.errorTips;
          this.refreshVerify();
        }
      );
    },

    refreshVerify() {
      //刷新验证方式
      if (this.verifyType === 1) {
        this.geetest_param.gt_state = false;
        this.$refs.geetBtn.reset();
      } else if (this.verifyType === 2) {
        this.$refs.kapkeyInput.getImageKey();
      }
    },
    changeVerifyType(type) {
      console.log(type);
      this.verifyType = type;
    },

    closeModal() {
      this.showModal = false;
      this.message = "";
    },
    bodyClick() {
      this.$refs.accountInput.changeCycode = false;
    }
  },
  watch: {
    verifyType(newValue, oldValue) {
      newValue === 2 && this.$refs.kapkeyInput.getImageKey();
    }
  },
  mounted() {
    this.lang = getParams("lang") || this.getCookie("lang") || "zh_CN";
    this.lang !== "zh_CN" && (this.geet_lang = "en");
    if (!(this.lang == "zh_CN")) {
      document.title = "Retrieve password";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base.scss";
.title {
  text-align: center;
  width: auto;
}
.content-form {
  .section {
    .bar-input {
      width: 433px;
      display: inline-block;
      vertical-align: middle;
    }
    .link {
      width: 110px;
    }
    .geet {
      width: 290px;
    }
  }
}
.modal-tips {
  opacity: 0.4;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  line-height: 19px;
  width: 317px;
  margin: 0 auto;
}
.modal-btn-container {
  width: 100%;
  margin-top: 50px;
  .modal-btn {
    width: 140px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forgetPassword_index/forgetPassword_index.vue